import { useEffect, useState } from "react";
import { api } from "../api";
import { getToken } from "../utils/local-storage.util";

const INITIAL_STATE = { resolved: false, token: null };

/**
 * Fetches a short-lived Featurebase identity JWT from the backend for the
 * logged-in user. The token is passed to Featurebase via bootOptions.jwtToken
 * so feedback/posts are tied to the authenticated user.
 *
 * Returns { resolved, token }:
 * - resolved=false while the request is in flight (widget waits to boot)
 * - resolved=true, token=string on success (identified boot)
 * - resolved=true, token=null on failure (anonymous fallback boot)
 *
 * @param {boolean} enabled - whether identity should be fetched
 * @return {{ resolved: boolean, token: string|null }}
 */
const useFeaturebaseIdentity = (enabled) => {
	const [state, setState] = useState(INITIAL_STATE);

	useEffect(() => {
		if (!enabled) {
			setState(INITIAL_STATE);
			return undefined;
		}

		let cancelled = false;
		setState(INITIAL_STATE);

		api
			.get("/featurebase/token", {
				headers: { Authorization: "Bearer " + getToken() },
			})
			.then((res) => {
				if (!cancelled) {
					setState({ resolved: true, token: res?.data?.result?.token ?? null });
				}
			})
			.catch(() => {
				if (!cancelled) {
					setState({ resolved: true, token: null });
				}
			});

		return () => {
			cancelled = true;
		};
	}, [enabled]);

	return state;
};

export default useFeaturebaseIdentity;
